import { render, staticRenderFns } from "./McmCardHeader.vue?vue&type=template&id=b1540bca&scoped=true&"
import script from "./McmCardHeader.vue?vue&type=script&lang=ts&"
export * from "./McmCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./McmCardHeader.vue?vue&type=style&index=0&id=b1540bca&lang=scss&scoped=true&"
import style1 from "./McmCardHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1540bca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardSubtitle,VCardTitle,VSpacer})
